import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "modal_details_expense",
  tabindex: "-1",
  "data-bs-backdrop": "static",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-xl" }
const _hoisted_3 = { class: "modal-content position-relative" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = {
  class: "modal-title",
  id: "varyingModalLabel"
}
const _hoisted_6 = { class: "modal-body" }
const _hoisted_7 = { class: "row mb-3" }
const _hoisted_8 = { class: "col-md-12" }
const _hoisted_9 = { class: "title-h4" }
const _hoisted_10 = { class: "row mb-5" }
const _hoisted_11 = { class: "col-md-6" }
const _hoisted_12 = { class: "form-group mb-1 mt-1" }
const _hoisted_13 = { class: "d-inline-block w-160" }
const _hoisted_14 = { class: "col-md-6" }
const _hoisted_15 = { class: "form-group mb-1 mt-1" }
const _hoisted_16 = { class: "d-inline-block w-160" }
const _hoisted_17 = { class: "col-md-6" }
const _hoisted_18 = { class: "form-group mb-1 mt-1" }
const _hoisted_19 = { class: "d-inline-block w-160" }
const _hoisted_20 = { class: "col-md-6" }
const _hoisted_21 = { class: "form-group mb-1 mt-1" }
const _hoisted_22 = { class: "d-inline-block w-160" }
const _hoisted_23 = { class: "col-md-6" }
const _hoisted_24 = { class: "form-group mb-1 mt-1" }
const _hoisted_25 = { class: "d-inline-block w-160" }
const _hoisted_26 = { class: "col-md-6" }
const _hoisted_27 = {
  key: 0,
  class: "form-group mb-1 mt-1"
}
const _hoisted_28 = { class: "d-inline-block w-160" }
const _hoisted_29 = {
  key: 1,
  class: "form-group mb-1 mt-1"
}
const _hoisted_30 = { class: "timeline-content" }
const _hoisted_31 = { class: "d-inline-block w-160" }
const _hoisted_32 = { class: "badges badges-bg badges-actif" }
const _hoisted_33 = { class: "col-md-12" }
const _hoisted_34 = { class: "form-group mb-1 mt-1" }
const _hoisted_35 = { class: "d-inline-block w-160" }
const _hoisted_36 = { class: "col-md-12" }
const _hoisted_37 = { class: "form-group mb-1 mt-1" }
const _hoisted_38 = { class: "d-inline-block w-160" }
const _hoisted_39 = { class: "row mb-3" }
const _hoisted_40 = { class: "col-md-12" }
const _hoisted_41 = { class: "title-h4" }
const _hoisted_42 = {
  key: 0,
  class: "tab-pane fade in active show",
  id: "expenses",
  style: {"overflow-x":"auto"}
}
const _hoisted_43 = { class: "datatables table table-striped table-bordered" }
const _hoisted_44 = { class: "thead-dark" }
const _hoisted_45 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader_gif = _resolveComponent("loader-gif")!
  const _component_btn_delete = _resolveComponent("btn-delete")!
  const _component_not_found = _resolveComponent("not-found")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.isRequestPayment)
          ? (_openBlock(), _createBlock(_component_loader_gif, { key: 0 }))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h5", _hoisted_5, _toDisplayString(_ctx.i18n.t('layout.sidbar.expenses.details')), 1),
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeModal('modal_details_expense', 'view'))),
            type: "button",
            class: "btn-close",
            "aria-label": "btn-close"
          })
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("h4", _hoisted_9, _toDisplayString(_ctx.i18n.t('views.clients.expense.payment.info')), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("b", _hoisted_13, _toDisplayString(_ctx.i18n.t('tables.expense.title')), 1),
                _createTextVNode(" : " + _toDisplayString(_ctx.expense?.title ?? ''), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("b", _hoisted_16, _toDisplayString(_ctx.i18n.t('tables.expense.category_name')), 1),
                _createTextVNode(" : "),
                _createElementVNode("span", null, _toDisplayString(_ctx.expense?.service?.category?.name ?? ''), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("b", _hoisted_19, _toDisplayString(_ctx.i18n.t('tables.expense.service_name')), 1),
                _createTextVNode(": "),
                _createElementVNode("span", null, _toDisplayString(_ctx.expense?.service?.name ?? ''), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("b", _hoisted_22, _toDisplayString(_ctx.i18n.t('tables.expense.total_amount')), 1),
                _createTextVNode(": " + _toDisplayString(_ctx.expense?.total_amount ?? 0) + " " + _toDisplayString(_ctx.i18n.t('symbole.currency.mad')), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("b", _hoisted_25, _toDisplayString(_ctx.i18n.t('tables.expense.total_amount_paid')), 1),
                _createTextVNode(" : " + _toDisplayString(_ctx.expense?.total_amount_paid ?? 0) + " " + _toDisplayString(_ctx.i18n.t('symbole.currency.mad')), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_26, [
              (_ctx.expense?.remaining_amount > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                    _createElementVNode("b", _hoisted_28, _toDisplayString(_ctx.i18n.t('tables.expense.remaining_amount')), 1),
                    _createTextVNode(" : " + _toDisplayString(_ctx.expense?.remaining_amount ?? 0) + " " + _toDisplayString(_ctx.i18n.t('symbole.currency.mad')), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.expense?.remaining_amount <= 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                    _createElementVNode("p", _hoisted_30, [
                      _createElementVNode("b", _hoisted_31, _toDisplayString(_ctx.i18n.t('tables.subscription_member.remaining_amount')), 1),
                      _createTextVNode(": "),
                      _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.i18n.t('tables.subscription_member.paid')), 1)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("b", _hoisted_35, _toDisplayString(_ctx.i18n.t('tables.expense.description')), 1),
                _createTextVNode(" : " + _toDisplayString(_ctx.expense?.description ?? ''), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_36, [
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("b", _hoisted_38, _toDisplayString(_ctx.i18n.t('tables.expense.date')), 1),
                _createTextVNode(" : " + _toDisplayString(_ctx.formatDate(_ctx.expense?.date)), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_39, [
            _createElementVNode("div", _hoisted_40, [
              _createElementVNode("h4", _hoisted_41, _toDisplayString(_ctx.i18n.t('views.clients.expense.payment.paid')), 1)
            ])
          ]),
          (_ctx.expensesPaymentsList?.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                _createElementVNode("table", _hoisted_43, [
                  _createElementVNode("thead", _hoisted_44, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", null, _toDisplayString(_ctx.i18n.t('tables.payment.paymentDate')), 1),
                      _createElementVNode("th", null, _toDisplayString(_ctx.i18n.t('tables.payment.paymentMethod')), 1),
                      _createElementVNode("th", null, _toDisplayString(_ctx.i18n.t('tables.payment.chequeName')), 1),
                      _createElementVNode("th", null, _toDisplayString(_ctx.i18n.t('tables.payment.bankName')), 1),
                      _createElementVNode("th", null, _toDisplayString(_ctx.i18n.t('tables.payment.chequeNum')), 1),
                      _createElementVNode("th", null, _toDisplayString(_ctx.i18n.t('tables.payment.dueDate')), 1),
                      _createElementVNode("th", null, _toDisplayString(_ctx.i18n.t('tables.payment.amount_paid')), 1),
                      _createElementVNode("th", null, _toDisplayString(_ctx.i18n.t('tables.action')), 1)
                    ])
                  ]),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.expensesPaymentsList, (transaction) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: transaction?.id
                      }, [
                        _createElementVNode("td", null, _toDisplayString(_ctx.formatDate(transaction?.paymentDate)), 1),
                        _createElementVNode("td", null, _toDisplayString(transaction.paymentMethod), 1),
                        _createElementVNode("td", null, _toDisplayString(transaction.chequeName), 1),
                        _createElementVNode("td", null, _toDisplayString(transaction?.bankName), 1),
                        _createElementVNode("td", null, _toDisplayString(transaction?.chequeNum), 1),
                        _createElementVNode("td", null, _toDisplayString(_ctx.formatDate(transaction?.dueDate)), 1),
                        _createElementVNode("td", null, _toDisplayString(transaction?.amount_paid ?? 0.00) + " " + _toDisplayString(_ctx.i18n.t('symbole.currency.mad')), 1),
                        _createElementVNode("td", null, [
                          _createVNode(_component_btn_delete, {
                            onDelete: ($event: any) => (_ctx.Delete(transaction?.id))
                          }, null, 8, ["onDelete"])
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_45, [
                _createVNode(_component_not_found, {
                  text: _ctx.i18n.t('message.data_not_found.title'),
                  icon: "warning"
                }, null, 8, ["text"])
              ]))
        ])
      ])
    ])
  ]))
}